<script setup>

import { inject, ref, computed, watch, onMounted } from 'vue';
import { 
	estChampHerite,
	estChampSurcharge } from '@/scripts/global.js';

const getTypeObjet = inject('getTypeObjet');
const selectionSchema = inject('selectionSchema');

const { typeObjet, champ, selectionne } = defineProps({
	typeObjet: Object,
	champ: Object,
  	selectionne: Boolean
});

const emit = defineEmits(['selectionPlageChamps']);

const composant = ref(null);

const estPopulation = computed(() => {
	return champ.type === 'ChampPopulation';
});

const estHerite = computed(() => {
	return estChampHerite(typeObjet, champ);
});

const estSurcharge = computed(() => {
	return estChampSurcharge(champ);
});

watch(() => selectionne, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionne) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

function selectionnerPlageChamps() {
	if (!selectionne) {
		emit('selectionPlageChamps', champ);
	}
}

function commencerGlisserDeplacer(event) {
	var selection;
	if (selectionSchema.value.champs.length > 1) {
		selection = selectionSchema.value.champs.slice();
		if (!selection.includes(champ)) {
			selection.push(champ);
		}
	} else {
		selection = [champ];
	}
	const donneesTransfert = {
		type: 'CHAMPS',
		champs: selection
	};
	event.dataTransfer.setData('text/plain', JSON.stringify(donneesTransfert));
	event.dataTransfer.dropEffect = 'copy';
}

</script>

<template>
	<div 
  	ref="composant" 
	class="champ"
	draggable="true"
	@dragstart="commencerGlisserDeplacer"
	@click.shift.exact.stop="selectionnerPlageChamps">
		<div class="nom-champ">{{ champ.nom }}</div>
		<i v-if="champ.typeLien != null" class="fa-solid fa-link icone lien" v-tooltip="`Champ de lien avec le type d'objet ${getTypeObjet(champ.typeDonnee.id).nom}`" />
		<i v-else class="icone invisible" />
		<i v-if="estHerite" class="fa-solid fa-arrow-turn-down icone herite" v-tooltip="`Champ hérité du type d'objet ${getTypeObjet(champ.idTypeObjet).nom}`" />
		<i v-else-if="estSurcharge" class="fa-solid fa-arrow-turn-down icone surcharge" v-tooltip="`Surcharge du champ hérité du type d'objet ${getTypeObjet(champ.idTypeObjetChampSurcharge).nom}`" />
		<i v-else class="icone invisible" />
		<i v-if="champ.formuleEnErreur" class="fa-solid fa-triangle-exclamation icone erreur" v-tooltip="'Champ en erreur'" />
		<i v-else class="icone invisible" />
		<i v-if="champ.modeEvaluation == 'CLE'" class="fa-solid fa-key icone cle" v-tooltip="'Champ clé'" />
		<i v-else-if="champ.modeEvaluation == 'CLE_AUTO'" class="fa-solid fa-key icone cle" v-tooltip="'Champ clé (auto)'" />
		<i v-else-if="champ.modeEvaluation == 'SAISIE'" class="fa-regular fa-arrow-right-to-bracket icone saisie" v-tooltip="'Champ saisi'" />
		<i v-else-if="champ.modeEvaluation == 'CALCUL'" class="fa-solid fa-calculator icone calcul" v-tooltip="'Champ calculé'" />
		<i v-else-if="champ.modeEvaluation == 'INDEFINI'" class="fa-solid fa-question icone indefini" v-tooltip="'Mode d\'évaluation non défini'" />
	</div>
</template>

<style scoped>

.champ {
	display: flex;
	user-select: none;
	padding: 0px 5px;
	align-items: center;
}

.nom-champ {
	width: 10rem;
	font-weight: inherit;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
}

.icone {
	padding: 1px;
	margin: 2px 4px;
	width: 1rem;
	text-align: center;
}
.cle {
	color: var(--couleur-champ-cle);
}
.saisie {
	color: var(--couleur-champ-saisi);
}
.calcul {
	color: var(--couleur-champ-calcule);
}

.indefini {
	color: var(--couleur-erreur);
}

.lien {
	color: var(--couleur-champ-lien);
}

.herite {
	color: var(--couleur-champ-herite);
}

.surcharge {
	color: var(--couleur-champ-surcharge);
}

.erreur {
	color: var(--couleur-valeur-en-erreur);
}

</style>